export default "__VITE_ASSET__ADpdRRSQ__"